'use client'
import {
    InvitationContext,
    useCreateInvitationsConcern
} from "@web-libs/features/appointments/application/invitations/use-invitations";
import {createConcernProvider} from "@web-libs/util/hocs/create-provider";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";

export const InvitationsProvider = createConcernProvider(
    InvitationContext.Provider,
    useCreateInvitationsConcern,
    'InvitationsProvider'
)
